const $ = window.jQuery;


const _getCookie = function (name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}

const analytics = {
    init: () => {
        const acceptall = _getCookie('viewed_cookie_policy');
        const value = _getCookie('cookielawinfo-checkbox-analytics');

        if ((value === "yes") && acceptall === 'yes') {

            $(".ctaga").on("click", function(e) {

                var event = $(this).data("event");
                var category = $(this).data("category"); // arrow + nome modulo
                var label = $(this).data("label"); // togliamo nome modulo

                gtag(
                    'event', event, {
                        'event_category': category,
                        'event_label': label
                    });


            });

            $(".countries-container").on("click", function() {
                gtag(
                    'event', 'click', {
                        'event_category': 'button',
                        'event_label': 'Select Country'
                    });
            })

            $(".select-container").on('select2:select', function(e) {
                const data = e.params.data;
                const event = $(data.element).data('event');
                const category = $(data.element).data('category');
                const label = $(this).data("label");

                gtag(
                    'event', event, {
                        'event_category': category,
                        'event_label': label
                    });

            })

            $('.video_player').on("click", function() {
                const event = $(this).data("event");
                const category = $(this).data("category");
                //    var label = $(this).data("label");

                gtag(
                    'event', event, {
                        'event_category': category,
                        'event_label': window.location.pathname
                    });
            })

            $('#menu-footer-follow-us li a').on("click", function() {

                const label = $(this).text();
                gtag(
                    'event', 'click', {
                        'event_category': 'Text-footer-social',
                        'event_label': label
                    });
            })

            document.addEventListener('wpcf7mailsent', function(event) {
                gtag(
                    'event', 'click', {
                        'event_category': 'Submit',
                        'event_label': 'Contact Us'
                    });
            }, false);
        }
    }
};
export default analytics;